(() => {
  const TOAST_ID = 'StarumiCopyEmailToast';
  let toastTimer;

  const getToast = () => {
    let toast = document.getElementById(TOAST_ID);

    if (!toast) {
      toast = document.createElement('div');
      toast.id = TOAST_ID;
      toast.className = 'starumi-copy-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.setAttribute('aria-atomic', 'true');
      document.body.appendChild(toast);
    }

    return toast;
  };

  const showToast = (message) => {
    const toast = getToast();
    window.clearTimeout(toastTimer);
    toast.textContent = message;
    toast.classList.add('is-visible');

    toastTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 1800);
  };

  const fallbackCopy = (value) => {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    textarea.remove();
    return copied;
  };

  const copyEmail = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(value);
        return true;
      } catch (error) {
        return fallbackCopy(value);
      }
    }

    return fallbackCopy(value);
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-starumi-copy-email]');
    if (!trigger) return;

    event.preventDefault();
    const email = (trigger.dataset.emailValue || '').trim();
    if (!email) {
      showToast('Unable to copy email address');
      return;
    }

    trigger.disabled = true;
    const copied = await copyEmail(email);
    trigger.disabled = false;
    showToast(copied ? 'Copied Successfully' : 'Unable to copy email address');
  });
})();
